module.exports = __webpack_public_path__ + "img/logo.ad580b06.png";